export default __webpack_public_path__ + "static/icon-search-large-e81b8c27bb20014cc8eec4f9f6c9b1d1.png";